/**
 * Employee Web — `/me/lifecycle` landing route.
 *
 * Phase 20 Plan 02 Task 8. Renders <MeLifecycleLanding> backed by
 * `useMeLifecycleRunList`. Permission gate: `lifecycle:read:self`.
 */
import type { JSX } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { requirePermission } from "@linkhr/auth";
import { MeLifecycleLanding } from "../features/lifecycle/MeLifecycleLanding";

export const Route = createFileRoute("/_auth/me/lifecycle")({
  staticData: { breadcrumb: { labelKey: "lifecycle:me.lifecycle.page.title" } },
  beforeLoad: requirePermission({
    anyOf: ["lifecycle:read:self"],
    defaultRoute: "/me/overview",
  }),
  component: MeLifecycleRoute,
});

function MeLifecycleRoute(): JSX.Element {
  return <MeLifecycleLanding />;
}
